"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SNACKBAR_TIMEOUT = exports.TYPE_ERROR = void 0;
// These types are currently only used inside the snackbar component
exports.TYPE_ERROR = 'error';
exports.SNACKBAR_TIMEOUT = 8000;
//# sourceMappingURL=types.js.map